import React, {Component} from 'react'
import PropTypes from 'prop-types'
import throttle from 'lodash/throttle'
// import { api } from '../../../../api/integrationAPI'

import './SwipeableShowcase.scss'

export default class SwipeableShowcase extends Component {

  constructor (props) {
    super(props)

    this.state = {
      previousTouchX: null
    }

    this.onGridMove = this.onGridMove.bind(this)
  }

  componentDidMount () {
    let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    if (!iOS) {
      document.getElementsByClassName('js-top-showcase')[0].addEventListener('touchmove', throttle(this.onGridMove, 300), false)
      document.getElementsByClassName('js-top-showcase')[0].addEventListener('touchstart', e => this.onGridTouchStart(e), false)
      document.getElementsByClassName('js-top-showcase')[0].addEventListener('touchend', e => this.onGridTouchEnd(e), false)
    }
  }

  onGridTouchStart (e) {
    let touch = e.touches[0]
    this.setState({
      previousTouchX: touch.pageX,
      touchEnded: false
    })
  }

  onGridTouchEnd (e) {
    const grid = document.getElementsByClassName('js-top-showcase')[0]

    grid.classList.remove('in_grid__swipeable-showcase--pulled-right', 'in_grid__swipeable-showcase--pulled-left')

    this.setState({
      touchEnded: true
    })
  }

  onGridMove (e) {
    if (!(this.props.products && this.props.products.length < 4)) {
      return
    }
    if (this.props.products.length === 0) return
    const grid = document.getElementsByClassName('js-top-showcase')[0]
    let scrollLeft = grid.scrollLeft

    let touch = e.touches[0]

    if (this.state.previousTouchX < touch.pageX && scrollLeft === 0 && !this.state.touchEnded) {
      grid.classList.add('in_grid__swipeable-showcase--pulled-right')
    } else if (this.state.previousTouchX > touch.pageX && scrollLeft > 0 && !this.state.touchEnded && this.props.products.length > 4) {
      grid.classList.add('in_grid__swipeable-showcase--pulled-left')
    } else {
      grid.classList.remove('in_grid__swipeable-showcase--pulled-right', 'in_grid__swipeable-showcase--pulled-left')
    }
  }

  _renderItem (item, index) {
    const p = this.props.getProductInfo(item)
    // console.log('productInfo', p)
    return (
      <div className='swipeable_item js-scroll-x' key={index} onClick={() => this.props.showProduct(p.productId)} >
        <div className='swipeable_item__image--container js-scroll-x'>
          <img className='swipeable_item__image js-scroll-x' src={p.details.images[0]} alt='' />
        </div>
        <div className='swipeable_item__content js-scroll-x'>{p.details.title}</div>
        <div className='swipeable_item__price js-scroll-x'>${p.details.price}</div>
      </div>
    )
  }

  _renderItems () {
    const { products } = this.props
    if (!products || products.length < 1) {
      // return <div className='in_grid__no-products'>There are no products selected. Please, click on a picture to select one.</div>
      return null
    } else {
      return products.map((item, index) => {
        if (item.invisibleProduct) {
          return <div key={index} className='swipeable_item swipeable_item--invisible'></div>
        } else {
          return this._renderItem(item, index)
        }
      })
    }
  }

  render () {
    const {products} = this.props
    return (
      <div className={`in_grid__swipeable-showcase js-top-showcase js-scroll-x ${!products || products.length < 1 ? 'in_grid__swipeable-showcase--empty' : ''}`}>
        {this._renderItems()}
      </div>
    )
  }

  static propTypes = {
    products: PropTypes.array,
    showProduct: PropTypes.func,
    getProductInfo: PropTypes.func.isRequired
  }
}



// WEBPACK FOOTER //
// ./src/templates/insta/components/showcase/SwipeableShowcase.js